module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-not-found"
  }, [_c('page-header', {
    attrs: {
      "title": "Oops - We didn't find your site.",
      "subTitle": "But don't panic, we're here to help!"
    }
  }), _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitLogin.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("1. Most likely, you have probably just slightly misspelt the address"), _c('strong', [_vm._v(" " + _vm._s(_vm.siteAddress) + " ")]), _vm._v("so before we go any further please check that.")])]), _vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3)]), (_vm.inAppLogin) ? _c('div', {
    staticClass: "w-page-footer"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onClickBackToApp.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Back to app")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("2. Still here? Hmmm, perhaps you can't think of the correct address for the site you want;\n that's no problem, "), _c('a', {
    attrs: {
      "href": "https://teamwork.com/launchpad/login"
    }
  }, [_vm._v("you can use our generic login page")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("3. Oh dear, you're still here... OK, there is also the slim possibility that\n the account may have been cancelled, in which case we can restore it if there\n has been a mistake.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("4. Custom domain?: If you've added a custom domain to your account,\n you may have missed the last step... "), _c('a', {
    attrs: {
      "href": "https://support.teamwork.com/projects/general-settings/using-a-custom-domain-name"
    }
  }, [_vm._v("Setting up your custom domain")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("5. Contact Us: If something has gone wrong, just "), _c('a', {
    attrs: {
      "href": "https://www.teamwork.com/contact"
    }
  }, [_vm._v("drop us a quick note")]), _vm._v(" and we'll do our best to help.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ab20f4d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/SiteNotFound/SiteNotFound.vue
// module id = 592
// module chunks = 1